module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-3.jpg?v=f8eb8c1f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-3.jpg
 ** module id = 39
 ** module chunks = 1 2
 **/